import React from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import { object, string } from 'yup';
import AddLifeCycleStageForm from './AddLifeCycleStageForm';
import { useAddLifeCycleStageMutation } from 'src/services/ContactServices';
import { showToast } from 'src/utils/showToaster';

 export type LifeCycleStageFormValues ={
    stageName :string 
}

type Props = {
  onClose: () => void;
};

const AddLifeCycleStageFormWrapper = ({ onClose }: Props) => { 

    const [addLifeCycle] = useAddLifeCycleStageMutation()

  // Form Initial Values
  const initialValues: LifeCycleStageFormValues = {
    stageName : '',
  };

  // Validation Schema
  const validationSchema = object().shape({
    stageName : string().required('Please enter name'),
  });

  // Handle Submit
  const handleSubmit = (
    values: LifeCycleStageFormValues,
    { setSubmitting, resetForm }: FormikHelpers<LifeCycleStageFormValues>
  ) => {
    addLifeCycle(values).then((res: any) => {
        if (res?.error) {
          showToast("error", res?.error?.data?.message);
        } else {
          if (res?.data?.status) {
            showToast("success", res?.data?.message);
            resetForm();
            onClose();
          } else {
            showToast("error", res?.data?.message);
          }
        }
        setSubmitting(false);
      });
  };

  return (
    <Dialog open maxWidth='xs' fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <AddLifeCycleStageForm formikProps={formikProps} onClose={onClose} />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddLifeCycleStageFormWrapper;